export default __webpack_public_path__ + "static/media/wf-isf-perspectives-electric-vehicles_767x577.a3f0a002.jpg";